import React from 'react';
import { copy } from '../../copy';
import { ConfidenceBand } from './ConfidenceBand';
export function ConfidenceMatrix() {
  const m = copy.workbench.matrix;
  return <div className="space-y-4" data-id="element-94">
      <div className="rounded-2xl border border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] p-4" data-id="element-95">
        <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 dark:text-[#555] mb-2" data-id="element-96">
          Composite
        </div>
        <div className="flex items-center gap-3" data-id="element-97">
          <ConfidenceBand value={m.composite} fullWidth data-id="element-98" />
        </div>
      </div>
      <div className="space-y-3" data-id="element-99">
        {m.dimensions.map(d => <div key={d.label} className="space-y-1" data-id="element-100">
            <div className="flex items-center justify-between text-xs mb-1" data-id="element-101">
              <span className="text-slate-600 dark:text-[#a3a3a3]" data-id="element-102">
                {d.label}
              </span>
            </div>
            <ConfidenceBand value={d.value} fullWidth data-id="element-103" />
          </div>)}
      </div>
    </div>;
}